import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { styled } from 'twin.macro'
import type { TFormProps } from './interface'
import baseStyle, { fieldsStyle } from './styles'

const StyledForm = styled.form(() => [baseStyle, fieldsStyle])

const Form = (props: TFormProps) => {
  const methods = useForm({ mode: 'onChange' })
  const { children } = props
  const { onSubmit, ...rest } = props

  return (
    <FormProvider {...methods}>
      <StyledForm onSubmit={methods.handleSubmit(onSubmit)} {...rest}>
        {children}
      </StyledForm>
    </FormProvider>
  )
}

export default Form
